import { render, staticRenderFns } from "./DeliveryOrderRejectionForm.vue?vue&type=template&id=7fa3a138&"
import script from "./DeliveryOrderRejectionForm.vue?vue&type=script&lang=js&"
export * from "./DeliveryOrderRejectionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports